import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import GroupRules from 'core/redux/reducers/partnerGroupRules';

export const deletePartnerGroupRule =
  (options: { id: string }, listId?: string): AppThunk =>
  async (dispatch) => {
    try {
      await apiClient.deletePartnerGroupRule(options);
      dispatch(GroupRules.actions.remove(options, listId));
    } catch (error) {
      console.error(error);
    }
  };
